<template>
    <div>
        <Spin fix v-show="isSpinShow">
            <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
            <div>Loading</div>
        </Spin>
        <Table id="gasAppliancesTable" ref="table" :width="tWidth" :data="showData" :columns="showColumns" stripe
            border highlight-row @on-current-change="onTableCurrentChange"></Table>
        
        <Row type="flex" align="bottom" style="padding-bottom: 10px;margin-top: 10px;">
            <Col span="4" style="padding-right: 10px;">
            <Button type="success" long @click="onClickInsert">添加燃气用具</Button>
            </Col>
            <Col span="4" style="padding-right: 10px;">
            <Button type="warning" long @click="onClickUpdate">修改燃气用具</Button>
            </Col>
            <Col span="4" style="padding-right: 10px;">
            <Button type="error" long @click="onClickDelete">删除燃气用具</Button>
            </Col>
            <Col span="11" style="padding-right: 10px;">
            <Page style="padding-top: 10px;text-align:right" :current="currentPage" :total="dataCount" :page-size="pageSize" show-sizer
                show-total @on-change="changePage" @on-page-size-change="changePageSize"></Page>
            </Col>
        </Row>

        <!-- 模态框Insert -->
        <Modal v-model="isShowModal.insert" :mask-closable="false" width="380">
            <p slot="header" style="color:#19be6b;text-align:center">
                <Icon type="md-create" />
                <span>添加燃气用具</span>
            </p>
            <Form ref="formInsert" :label-width="100" :model="formInsert" :rules="insertRule">
                <FormItem prop="contrastGasAppliancesName" label="燃气用具：">
                    <Input v-model="formInsert.contrastGasAppliancesName" placeholder="请输入燃气用具..."></Input>
                </FormItem>
                <FormItem prop="contrastGasAppliancesUsageCycle" label="检验周期：">
                    <InputNumber :step="1" :precision="0" v-model="formInsert.contrastGasAppliancesUsageCycle"
                        placeholder="请输入检验周期..." style="width:248px;"></InputNumber>
                </FormItem>
                <FormItem prop="contrastGasAppliancesUsageCycleUnit" label="周期单位：">
                    <Input v-model="formInsert.contrastGasAppliancesUsageCycleUnit" placeholder="请输入检验周期单位..."></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="success" size="large" long :loading="isLoadingButton" @click="commitInsert">添加</Button>
            </div>
        </Modal>

        <!-- 模态框update -->
        <Modal v-model="isShowModal.update" :mask-closable="false" width="380">
            <p slot="header" style="color:#ff9900;text-align:center">
                <Icon type="md-create" />
                <span>处理燃气用具</span>
            </p>
            <Form ref="formUpdate" :label-width="100" :model="formUpdate" :rules="insertRule">
                <FormItem prop="contrastGasAppliancesName" label="燃气用具：">
                    <Input v-model="formUpdate.contrastGasAppliancesName" placeholder="请输入燃气用具..."></Input>
                </FormItem>
                <FormItem prop="contrastGasAppliancesUsageCycle" label="检验周期：">
                    <InputNumber :step="1" :precision="0" v-model="formUpdate.contrastGasAppliancesUsageCycle"
                        placeholder="请输入检验周期..." style="width:248px;"></InputNumber>
                </FormItem>
                <FormItem prop="contrastGasAppliancesUsageCycleUnit" label="周期单位：">
                    <Input v-model="formUpdate.contrastGasAppliancesUsageCycleUnit" placeholder="请输入检验周期单位..."></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="warning" size="large" long :loading="isLoadingButton" @click="commitUpdate">修改</Button>
            </div>
        </Modal>

        <!-- 模态框delete -->
        <Modal v-model="isShowModal.delete" :mask-closable="false" width="380">
            <p slot="header" style="color:#ed4014;text-align:center">
                <Icon type="md-create" />
                <span>删除燃气用具</span>
            </p>
            <div style="color:#ed4014;text-align:center">确认删除当前选中数据？</div>
            <div slot="footer">
                <Button type="error" size="large" long :loading="isLoadingButton" @click="commitDelete">删除</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
    export default {
        name: "gas_appliances",
        created() {
            this.showPage();
        },
        data() {
            const validateCircle = (rule, value, callback) => {
                if (value <= 0) {
                    callback(new Error("检验周期必须为正数..."));
                } else {
                    callback();
                }
            };
            const validateCircleUnit = (rule, value, callback) => {
                console.log(typeof(value) + "+++++" + value)
                if (["年", "月", "日"].indexOf(value) == -1) {
                    callback(new Error('检验周期单位必须是年或月或日...'));
                } else {
                    callback();
                }
            };
            return {
                tWidth: document.body.clientWidth * 0.8,
                isShowModal: {
                    search: false,
                    insert: false,
                    update: false,
                    delete: false
                },
                isLoadingButton: false,
                isSpinShow: false,
                currentPage: 1,
                dataCount: 0,
                pageSize: 10,
                showData: [],
                showColumns: [{
                        title: "编号",
                        key: "contrastGasAppliancesId",
                        width: 95
                    },
                    {
                        title: "燃气用具",
                        key: "contrastGasAppliancesName"
                    },
                    {
                        title: "检验周期",
                        key: "contrastGasAppliancesUsageCycle"
                    },
                    {
                        title: "检验周期单位",
                        key: "contrastGasAppliancesUsageCycleUnit"
                    },
                    {
                        title: "录入时间",
                        key: "contrastGasInsertDatestamp",
                        render: function(h, params) {
                            return h(
                                "div",
                                global.dateFtt(
                                    "yyyy-MM-dd hh:mm:ss",
                                    new Date(this.row.contrastGasInsertDatestamp)
                                )
                            ); /*这里的this.row能够获取当前行的数据*/
                        }
                    }
                ],
                currentTableRow: null,
                searchParam: {},
                formInsert: {
                    contrastGasAppliancesName: "",
                    contrastGasAppliancesUsageCycle: 0,
                    contrastGasAppliancesUsageCycleUnit: ""
                },
                insertRule: {
                    contrastGasAppliancesName: [{
                        required: true,
                        message: "请输入燃气用具...",
                        trigger: "blur"
                    }],
                    contrastGasAppliancesUsageCycle: [{
                        required: true,
                        validator: validateCircle,
                        trigger: "change"
                    }],
                    contrastGasAppliancesUsageCycleUnit: [{
                        required: true,
                        validator: validateCircleUnit,
                        trigger: 'blur'
                    }]
                },
                formUpdate: {
                    contrastGasAppliancesName: "",
                    contrastGasAppliancesUsageCycle: 0,
                    contrastGasAppliancesUsageCycleUnit: ""
                },
                updateRule: {},
                formDelete: {}
            };
        },
        methods: {
            changePage(index) {
                this.currentPage = index;
                this.showPage();
            },
            changePageSize(size) {
                this.pageSize = size;
                this.showPage();
            },
            showPage() {
                var that = this;
                that.isSpinShow = true;
                $.ajax({
                    url: "/api/gasAppliances/selectPage?page=" +
                        this.currentPage +
                        "&pageAmount=" +
                        this.pageSize,
                    contentType: "application/json",
                    type: "post",
                    data: JSON.stringify(that.searchParam),
                    dataType: "json",
                    success: function(data) {
                        if (data.errorCode != 0) {
                            that.$Notice.error({
                                title: "异常",
                                desc: data.errorInfo
                            });
                            return;
                        }
                        that.showData = data.body.resultList;
                        that.dataCount = data.body.amount;
                        that.isSpinShow = false;
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    }
                });
            },
            onClickInsert() {
                this.isShowModal.insert = true;
            },
            onClickUpdate() {
                if (this.currentTableRow != null) {
                    this.isShowModal.update = true;
                    var that = this;
                    that.formUpdate.contrastGasAppliancesId = this.currentTableRow.contrastGasAppliancesId;
                    that.formUpdate.contrastGasAppliancesName = this.currentTableRow.contrastGasAppliancesName;
                    that.formUpdate.contrastGasAppliancesUsageCycle = this.currentTableRow.contrastGasAppliancesUsageCycle;
                    that.formUpdate.contrastGasAppliancesUsageCycleUnit = this.currentTableRow.contrastGasAppliancesUsageCycleUnit;
                } else {
                    this.$Notice.error({
                        title: "警告",
                        desc: "请选择一条数据！"
                    });
                }
            },
            onClickDelete() {
                if (this.currentTableRow != null) {
                    this.isShowModal.delete = true;
                } else {
                    this.$Notice.error({
                        title: "警告",
                        desc: "请选择一条数据！"
                    });
                }
            },
            onTableCurrentChange(currentRow, oldCurrentRow) {
                this.currentTableRow = currentRow;
            },
            commitInsert() {
                var that = this;
                that.$refs["formInsert"].validate(valid => {
                    if (valid) {
                        var insertCondition = that.formInsert;
                        that.isLoadingButton = true;
                        $.ajax({
                            url: "/api/gasAppliances/insert",
                            contentType: "application/json",
                            type: "post",
                            data: JSON.stringify(insertCondition),
                            dataType: "json",
                            success: function(data) {
                                if (data.errorCode != 0) {
                                    that.$Notice.error({
                                        title: "异常",
                                        desc: data.errorInfo
                                    });
                                    that.isLoadingButton = false;
                                    that.isShowModal.insert = false;
                                    return;
                                }
                                that.isLoadingButton = false;
                                that.isShowModal.insert = false;
                                that.$Notice.success({
                                    title: "添加成功！"
                                });
                                that.showPage();
                            },
                            error: function(textStatus) {
                                that.$Notice.error({
                                    title: "异常",
                                    desc: "接口请求异常"
                                });
                            }
                        });
                    }
                });
            },
            commitUpdate() {
                var that = this;
                that.$refs["formUpdate"].validate(valid => {
                    if (valid) {
                        var updateCondition = that.formUpdate;
                        that.isLoadingButton = true;
                        $.ajax({
                            url: "/api/gasAppliances/update",
                            contentType: "application/json",
                            type: "post",
                            data: JSON.stringify(updateCondition),
                            dataType: "json",
                            success: function(data) {
                                if (data.errorCode != 0) {
                                    that.$Notice.error({
                                        title: "异常",
                                        desc: data.errorInfo
                                    });
                                    that.isLoadingButton = false;
                                    that.isShowModal.update = false;
                                    return;
                                }
                                that.isLoadingButton = false;
                                that.isShowModal.update = false;
                                that.$Notice.success({
                                    title: "修改成功！"
                                });
                                that.showPage();
                            },
                            error: function(textStatus) {
                                that.$Notice.error({
                                    title: "异常",
                                    desc: "接口请求异常"
                                });
                            }
                        });
                    }
                });
            },
            commitDelete() {
                var that = this;
                var deleteCondition = {};
                deleteCondition["contrastGasAppliancesId"] =
                    that.currentTableRow.contrastGasAppliancesId;
                that.isLoadingButton = true;
                $.ajax({
                    url: "/api/gasAppliances/delete",
                    contentType: "application/json",
                    type: "post",
                    data: JSON.stringify(deleteCondition),
                    dataType: "json",
                    success: function(data) {
                        if (data.errorCode != 0) {
                            that.$Notice.error({
                                title: "异常",
                                desc: data.errorInfo
                            });
                            that.isLoadingButton = false;
                            that.isShowModal.delete = false;
                            return;
                        }
                        that.isLoadingButton = false;
                        that.isShowModal.delete = false;
                        that.$Notice.success({
                            title: "删除成功！"
                        });
                        that.showPage();
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    }
                });
            }
        }
    };
</script>

<style scoped>
    #gasAppliancesTable /deep/ .ivu-table td,
    #gasAppliancesTable /deep/ .ivu-table th {
        min-width: 0;
        height: 30px;
        box-sizing: border-box;
        text-align: center;
        text-overflow: ellipsis;
        vertical-align: middle;
        border-bottom: 1px solid #e8eaec;
    }
</style>
